import React from 'react';

import ActionButton from 'components/action-button';
import { useSignInUpAfterCartExperiment } from 'experiments/use-sign-in-up-after-cart-experiment';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

const SignUpToContinueActionLink = () => {
  const showSignUpToContinue = useFlag(LaunchDarklyFlag.ENABLE_SIGNUP_CART_BUTTON_TEXT);
  const { openSignInModal } = useAuthContext();
  const isSignInUpAfterCartExperimentEnabled = useSignInUpAfterCartExperiment();

  const handleSignUpToContinuePress = () => {
    openSignInModal({
      navigateOnSuccessRoute: routes.cart,
    });
  };

  let buttonText = '';

  if (isSignInUpAfterCartExperimentEnabled) {
    buttonText = t('signUpOrLoginToContinue');
  } else {
    const buttonTextKey = showSignUpToContinue ? 'signUpToContinue' : 'continue';
    buttonText = t(buttonTextKey);
  }

  return (
    <ActionButton onPress={handleSignUpToContinuePress} fullWidth>
      {buttonText}
    </ActionButton>
  );
};

export default SignUpToContinueActionLink;
